// financial constants
import FINANCIAL_RISK_SCORES from '../constants/riskScores.constant.financial';

const getFinancialRiskScore = (riskScore) =>
  [...FINANCIAL_RISK_SCORES].find(
    ({min, max}) => min <= riskScore && riskScore <= max
  ) || [...FINANCIAL_RISK_SCORES].find(({min, max}) => !min && !max);

export default getFinancialRiskScore;
